<template>
  <div class="step">
    <div class="step--heading" :class="{ active: product_items.length > 0 }">
      <div class="inner">        
        <p>Products</p>
      </div>
    </div>
    <div class="step--body" v-show="product_items.length > 0">
      <div class="row">
        <div class="col-12" v-for="(product, index) in product_items" :key="index">
          <div
            class="product"
            :class="{active: index == selectedProduct}"
          >
            <div class="header"
            v-on:click="(selectedProduct != index) ? selectedProduct = index : selectedProduct = null" style="background-color:white">
              <div class="image">
                <img :src="product.p_r_medias[0].mediaUrl" alt />
              </div>

              <div class="details">
                <div>
                  <h3>{{ product.title }}</h3>
                  <p>{{ product.stockCode }}</p>
                </div>
              </div>

              <div class="pricing">
                <div>
                  <div style="color:#212529">{{ product.productPrice }} {{ currency_suffix}} {{ int_curr_symbol }} </div>
                </div>
              </div>
            </div>
            <div class="product-content" v-if="index == selectedProduct">
              <p>{{ product.shortDescription }}</p>
              <a class="btn btn-hover btn-primary" :href="'/product/' + product.stockCode">View Solution</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minMaxPricing from "../../mixins/min-max-pricing.js";

export default {
  name: "reconfigureProduct",
    props: {
        product_items: Array,
        step_count: Number,
        currency_suffix: String,
        int_curr_symbol: String,
        label_products: {
            type: String,
            required: true,
            default: "Products"
        }
    },
  data: function() {
    return {
      selectedProduct: null
    };
  }
};
</script>

<style lang="scss">
.product {
  border: 1px solid #ebebeb;
  background-color: white;
  margin-bottom: 20px;
  a {
    color: black;
  }
}
</style>
